import scrollToElement from "@ecom/ui/utils/scrollToElement"

export default function scrollToPersonalForm() {
  const itemApp = document.getElementById("app")
  const itemHeader = document.querySelector("header")
  if (itemApp && itemHeader) {
    const itemPosition = itemApp.getBoundingClientRect().top + window.scrollY
    window.scrollTo({
      top: itemPosition - itemHeader.offsetHeight,
      behavior: "smooth",
    })
  } else {
    scrollToElement(itemApp)
  }
}
